import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { class: "mb-3" };
var _hoisted_2 = { class: "relative mb-4 flex flex-nowrap items-stretch" };
var _hoisted_3 = ["placeholder", "aria-label", "disabled"];
var _hoisted_4 = /*#__PURE__*/ _createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    class: "h-5 w-5"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z",
        "clip-rule": "evenodd"
    })
], -1);
var _hoisted_5 = [
    _hoisted_4
];
export default /*#__PURE__*/ _defineComponent({
    __name: 'SearchBar',
    props: {
        readonly: Boolean
    },
    setup: function (__props) {
        var props = __props;
        var keyword = "";
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return (_isRef(keyword) ? (keyword).value = $event : keyword = $event); }),
                        onInput: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('capture', _unref(keyword))); }),
                        type: "search",
                        class: "relative w-full block w-[1px] min-w-max flex-auto rounded border border-solid border-neutral-300 bg-transparent bg-clip-padding px-3 py-[0.25rem] text-base font-normal leading-[1.6] text-neutral-700 outline-none transition duration-200 ease-in-out focus:z-[3] focus:border-primary focus:text-neutral-700 focus:shadow-[inset_0_0_0_1px_rgb(59,113,202)] focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:placeholder:text-neutral-200 dark:focus:border-primary",
                        placeholder: _ctx.$t('Cerca'),
                        "aria-label": _ctx.$t('Cerca'),
                        "aria-describedby": "button-addon2",
                        disabled: props.readonly
                    }, null, 40, _hoisted_3), [
                        [_vModelText, _unref(keyword)]
                    ]),
                    _createElementVNode("span", {
                        onClick: _cache[2] || (_cache[2] = function ($event) { return (_ctx.$emit('capture', _unref(keyword))); }),
                        class: "input-group-text flex items-center whitespace-nowrap rounded px-3 py-1.5 text-center text-base font-normal text-neutral-700 dark:text-neutral-200",
                        id: "basic-addon2",
                        style: { "cursor": "pointer" }
                    }, _hoisted_5)
                ])
            ]));
        };
    }
});
